import { render, staticRenderFns } from "./transaction-log-detail.vue?vue&type=template&id=08977dcc&scoped=true&"
import script from "./transaction-log-detail.vue?vue&type=script&lang=js&"
export * from "./transaction-log-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08977dcc",
  null
  
)

export default component.exports